import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import './plugins/base-components'
import './plugins/breakpoints'
import './plugins/lodash'

import './assets/styles/style.scss'

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL
}
window.axios = axios.create(axiosConfig)
window.axios.defaults.headers.common['Accept-Language'] = 'uk'

Vue.config.productionTip = false

sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
